// Build-time constants for this dashboard.
//
// Replaces the old root `config.js`, which was imported via a bare, absolute,
// root-relative specifier — a Vite-only trick that resolves against the
// project root and breaks the moment the app is not the Vite root.
//
// The two host values reach createDashboard as dashboard.config.js's `transport`.
// `API_URL` is a *default only*: the host passes `apiUrl` as a URL param and the
// dashboard's start() overwrites `settings.apiUrl` at boot. Hosts here are bare
// (no scheme, no path) — see @rdrive/data-transport (src/proxyFetcher.js).

/** rdrive integration proxy host. */
export const PROXY_URL = 'integration-proxy.rdrive.io';

/** Default rdrive API host, overridden by the `apiUrl` URL param at boot. */
export const API_URL = 'uk.rdrive.io';

/** GA4 measurement id — dashboard.config.js's `analytics.measurementId` (createAnalytics loads the tag). */
export const GA_MEASUREMENT_ID = 'G-QTYQ7961QF';
